<template>
  <MainCard>
    <rb-loader v-if="loading_status" v-model='configs' :contained="true" />
    <div v-else class="w-100">
      <div class="w-100 d-flex justify-space-between align-center pl-2">
          <div class="d-flex align-center ga-6">
              <v-btn class="px-6 py-5 d-flex" @click="confirm('/model-catchment')" color="neutral-35" variant="text"
                  icon="mdi-arrow-left"></v-btn>
              <h1 class="configuracoes-titulo">Configurações</h1>
              <rb-switch v-model="configuracoesStatus"
                  :label="configuracoesStatus ? 'Ativado' : 'Desativado'"
                  @change="toggleSwitchStatusModel()"
              />
          </div>
      </div>
      <v-sheet v-if="lastUpdates.dadosLastExec.length === 0" class="aleta-nao-processado mt-2">
        <p><strong><i>Atenção!</i></strong> Sua configuração ainda não foi processada. <strong>Essa ação pode demorar até 24h.</strong></p>
      </v-sheet>
      <div class="container-configuracoes">
        <div class="container-subtitle">
          <h1 class="configuracoes-subtitle">Captação de novos alunos</h1>
          
          <p class="configuracoes-descricao">Receba no registro do seus processos de captação de novos alunos a probabilidade de conversão de matrícula através da nossa inteligência artificial. As probabilidades serão aplicadas nos registros criados a partir do dia: <strong>31/03/2025.</strong><br/><br/>
  Alterações feitas podem levar até <span class="descricao-destacada">24h para serem processadas.</span></p>
          <v-btn class="px-6 py-5 d-flex elevation-0 mt-4" rounded="xl" color="primary-60" @click="showProcessPopup = true">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M5.25 6.75H0.75V5.25H5.25V0.75H6.75V5.25H11.25V6.75H6.75V11.25H5.25V6.75Z" fill="#F8FAF9"/>
            </svg>
            <p class="ml-2">Vincular processo</p>
          </v-btn>
        </div>
      </div>
      <div class="container-configuracoes">
        <ConfigurationCard
          ref="configCard"
          :items="configs"
          :processes="crm_process_response"
          :edulevels="crm_edulevel_response"
          :modalities="crm_modality_response"
          :offers="crm_offer_response"
          @confirm="handleProcessConfirm"
          @save="handleCardSave"
        />
      </div>
      <div v-if="configs" class="container-historico">
        <h1 class="configuracoes-subtitle">Últimas Atualizações</h1>
        <v-sheet v-if="hasUpdates" class="d-flex ga-16 w-100">
          <TableInsights
            :headers="[
              { title:'Processo', key:'processo' },
              { title:'', key:'' },
              { title:'Total de registros', key:'total_registro' },
              { title:'', key:'' },
              { title:'Atualizado em', key:'ultima_atualizacao' },
              { title:'', key:'' },
              { title:'', key:'' },
            ]"
            :items="rowsLastUpdateTable"
            :show-total="false"
            v-model:page="page"
            v-model:itemsPerPage="ipp"
            :items-per-page-options="[5,10,25,50]"
            :highlight-index="1"
            @row:click="handleRowClick"
          >
          </TableInsights>
        </v-sheet>
        <v-sheet v-if="!hasUpdates" class="d-flex flex-column justify-center align-center ga-2 w-100">
          <h3 class="configuracoes-subtitle">Nenhum atualização encontrada</h3>
          <p class="text-page">Sua configuração ainda não foi processada.</p>
          <p class="text-page"><strong>Essa ação pode demorar até 24h.</strong></p>
        </v-sheet>
      </div>

    </div>

    <BindingProcess
      v-model="showProcessPopup"
      :processes="crm_process_response"
      :edulevels="crm_edulevel_response"
      :modalities="crm_modality_response"
      :offers="crm_offer_response"
      @confirm="handleProcessConfirm"
      @cancel="showProcessPopup = false"
    />

  </MainCard>
</template>

<script>
import MainCard from '@/ai_studio/components/layout/MainCard.vue';
import RbLoader from "@/ai_studio/components/common/RbLoader.vue";
import ConfigurationCard from "@/captacao/components/ConfigurationCard.vue";
import BindingProcess from "../components/BindingProcess.vue";
import TableInsights from "../components/TableInsights.vue";
import { Post, Get } from "@/ai_studio/http/http.js";

export default {
  name: "CatchmentConfigurationView",
  components: {
    MainCard,
    RbLoader,
    ConfigurationCard,
    BindingProcess,
    TableInsights
  },
  data() {
    return {
      models: [],
      configs: [],
      lastUpdates: {},

      crm_process_response: [],
      crm_edulevel_response: [],
      crm_modality_response: [],
      crm_offer_response: [],

      isEditing: true,
      configuracoesStatus: true,
      showProcessPopup: false,
      filteredSteps: [],
      processes: {},
      predictions: null,
      applied_education_level: null,
      applied_training: null,
      application_data: null,
      application_form_status: null,
      formData: {
        segmentation_name: null,
        training_id: null,
        process: null,
        dropout_steps: null,
        conclusion_steps: null,
        education_level: null,
        modality: null,
        offers: null,
      },
      loading_status: true,
      val_loading_status: 0,
      train_title: "",
      selected_training: null,
      validation_object: null,
      version_form_status: null,
      scope: {},
      switch_: { status: false, label: "Desativado" },
      selected_version: [],
      selected_versions_json: {},
      tab: 'goal',
      show: false,
      application_model_show_details: false,
      showCards: {},
      showProcesses: {},
      warning_status: null,
      buttonClicked: false,
      requiredRule: [(v) => v !== null && v !== undefined && v !== ""],
      Rules: [
        (value) => {
          if (value?.length > 0 && value != "") return true;
          else {
            return "Por favor, preencha o campo acima";
          }
        },
      ],
      page: 1,
      ipp: 5,
    }
  },
  async mounted() {
    await this.fetchAll();  
    this.syncStatus();
  },

  computed: {
    rowsLastUpdateTable() {
      const source = Array.isArray(this.lastUpdates?.dadosLastExec)
        ? this.lastUpdates.dadosLastExec
        : [];

      return source.map((pred) => {
        const fields = pred?.fields ?? {};
        const total_registro = fields?.qtd_registers ?? 0;
        const ultima_atualizacao_raw = fields?.updated_at ?? null;

        const processId = fields?.process_id;
        const processoObj = this.crm_process_response.find(
          (proc) => String(proc.id) === String(processId)
        );

        const processoNome = processoObj?.nome || processoObj?.name || "—";

        return {
          processo: processoNome,
          total_registro,
          ultima_atualizacao: this.formatDateBR(ultima_atualizacao_raw),
        };
      });
    },

    hasUpdates() {
      return Array.isArray(this.rowsLastUpdateTable) && this.rowsLastUpdateTable.length > 0;
    }
  },

  methods: {
    async fetchAll() {
      try {
        this.loading_status = true;
        const [cfg, crmprocs, crmedulevel, crmmods, crmoffer, modeldata] = await Promise.all([
          Get("insights/getConfigByClient"),
          Get("listprocess"),
          Get("assistents/crm/listarNiveisEnsino?contexto=1"),
          Get("assistents/crm/listarModalidades?contexto=1"),
          Get("assistents/crm/listarLocais?contexto=1"),
          Get("getmodels"),
        ]);

        this.models = Array.isArray(modeldata) ? modeldata : (modeldata?.data ?? []);
        this.configs = Array.isArray(cfg?.data) ? cfg.data : (Array.isArray(cfg) ? cfg : []);
        this.lastUpdates = {
          dadosLastExec: Array.isArray(cfg?.dadosLastExec) ? cfg.dadosLastExec : [],
          configData: Array.isArray(cfg?.configData) ? cfg.configData : [],
        };

        this.crm_process_response = Array.isArray(crmprocs) ? crmprocs : (crmprocs?.data ?? []);
        this.crm_edulevel_response = Array.isArray(crmedulevel) ? crmedulevel : (crmedulevel?.data ?? []);
        this.crm_modality_response = Array.isArray(crmmods) ? crmmods : (crmmods?.data ?? []);
        this.crm_offer_response = Array.isArray(crmoffer) ? crmoffer : (crmoffer?.data ?? []);
      } catch (e) {
        console.error(e);
        this.$toast?.error?.("Não foi possível carregar os dados. Tente novamente.");
        this.lastUpdates = { dadosLastExec: [], configData: [] };
      } finally {
        this.loading_status = false;
      }
    },

    formatDateBR(v) {
      if (!v) return "-";
      if (typeof v === "string") {
        const m = v.match(/^(\d{4})[-/](\d{2})[-/](\d{2})/);
        if (m) return `${m[3]}/${m[2]}/${m[1]}`;
      }
      const d = new Date(v);
      return isNaN(d) ? "-" : d.toLocaleDateString("pt-BR");
    },
    toggleSelectAll() {
      if (this.isSelectAll) {
        this.formData.offers = [];
      } else {
        this.formData.offers = this.crm_offer_response
          .map((item) => item.id)
          .slice();
      }
    },
    toggleSelectAllEducation() {
      if (this.isSelectAlleducation) {
        this.formData.education_level = [];
      } else {
        this.formData.education_level = this.crm_edulevel_response
          .map((item) => item.id)
          .slice();
      }
    },
    toggleSelectAllModality() {
      if (this.isSelectAllmodality) {
        this.formData.modality = [];
      } else {
        this.formData.modality = this.crm_modality_response
          .map((item) => item.id)
          .slice();
      }
    },
    ChangeSwitchStatusWarning(text, value) {
      this.switch_.label = text;
      this.switch_.status = value;
    },

    syncStatus() {
      const id = this?.configs?.[0]?.fields?.model;
      if (!id) {
        this.configuracoesStatus = false;
        this.switch_.status = false;
        this.switch_.label = "Desativado";
        return;
      }

      const model = Array.isArray(this.models)
        ? this.models.find(m => String(m?.id) === String(id))
        : null;

      const isOn = Number(model?.active ?? 0) === 1;
      this.configuracoesStatus = isOn;
      this.switch_.status = isOn;
      this.switch_.label = isOn ? "Ativado" : "Desativado";
    },

    async toggleSwitchStatusModel() { 
      try {
        const modelPk = this?.configs?.[0]?.fields?.model;
        if (!modelPk) return;

        const willActivate = !this.switch_.status;
        this.switch_.status = willActivate;
        this.switch_.label = willActivate ? "Ativado" : "Desativado";

        const payload = { pk: modelPk, status: willActivate };
        await Post(JSON.stringify(payload), "insights/switchModelStatus");

        await this.fetchAll();
        this.syncStatus();
        this.$toast?.success?.("Status atualizado.");
      } catch (e) {
        console.error(e);
        this.$toast?.error?.("Falha ao alterar o status do modelo.");
      }
    },

    resetFormData() {
      this.formData = {
        segmentation_name: null,
        training_id: null,
        process: null,
        dropout_steps: null,
        conclusion_steps: null,
        education_level: null,
        modality: null,
        offers: null,
      };
    },
    confirm(route) {
      this.$router.push(route);
    },
    async handleProcessConfirm() {
      this.showProcessPopup = false;
      try {
        this.loading_status = true;
        const cfg = await Get("insights/getConfigByClient");
        this.configs = Array.isArray(cfg?.data) ? cfg.data : (Array.isArray(cfg) ? cfg : []);
        this.lastUpdates = cfg || {};
        this.syncStatus();
      } catch (err) {
        console.error(err);
        this.$toast?.error?.("Falha ao atualizar a configuração.");
      } finally {
        this.loading_status = false;
      }
    },

    async apiUpdateConfig(pk, configsObj) {
      const endpoint = `/api/insights/updateConfig/${pk}/`;
      const body = new URLSearchParams();
      body.set("configs", JSON.stringify(configsObj));
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body
      });

      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(`Falha ao atualizar pk=${pk}: ${res.status} ${text}`);
      }
      return res.json();
    },

    async handleCardSave(payloadOrPk, maybeConfigs) {
      try {
        this.loading_status = true;

        const { pk, configs } = typeof payloadOrPk === 'object'
          ? payloadOrPk
          : { pk: payloadOrPk, configs: maybeConfigs };

        if (!pk || !configs) {
          throw new Error('Payload inválido para salvar a configuração.');
        }

        await this.apiUpdateConfig(pk, configs);

        await this.fetchAll();
        this.syncStatus();

        this.$toast?.success?.('Configuração salva com sucesso!');
      } catch (err) {
        console.error(err);
        this.$toast?.error?.('Falha ao salvar a configuração.');
      } finally {
        this.loading_status = false;
      }
    },

    async saveAll() {
      try {
        this.loading_status = 1;

        const changes = this.$refs.configCard?.getChanges?.() || [];

        if (changes.length === 0) {
          this.loading_status = 0;
          this.$toast?.success?.("Nada para salvar.");
          return;
        }

        await Promise.all(
          changes.map(({ pk, configs }) => this.apiUpdateConfig(pk, configs))
        );

        this.configs = await Get("insights/getConfigByClient");
        this.syncStatus();
        this.loading_status = 0;
        this.$toast?.success?.("Configurações salvas com sucesso!");
      } catch (err) {
        this.loading_status = 0;
        console.error(err);
        this.$toast?.error?.("Falha ao salvar configurações.");
      }
    },

  }
};
</script>

<style>
.text-page {
  color: var(--Text-Neutral-Secondary, #2E3131);
  font-family: var(--Typescale-Body-Medium-Font-family, Roboto);
  font-size: var(--Typescale-Body-Medium-Font-size, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Typescale-Body-Medium-Line-height, 20px);
  letter-spacing: var(--Typescale-Body-Medium-Tracking, 0.25px);
}
.configuracoes-titulo {
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.configuracoes-subtitle {
  color: #191C1C;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.4px;
}

.configuracoes-descricao {
  color: var(--Palettes-Neutral-35, #505353);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  align-self: stretch;
  text-align: start;
}

.configuracoes-descricao span {
  font-weight: 700;
}

.container-subtitle {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}

.container-configuracoes {
  display: flex;
  width: 100%;
  padding: 16px 32px 32px 20px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
}

.container-historico {
  display: flex;
  padding: 0px 32px 32px 20px;
  margin-bottom: 56px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
}

.navigation-buttons {
	position: fixed;
	bottom: 0;
	left: var(--sidebar-width);
	right: 0;
	background: white;
	z-index: 2;
	transition: left 0.2s ease;
}

.buttons-container {
	padding: 16px 32px;
}

.action-buttons-container {
	margin-left: auto;
}

.aleta-nao-processado {
  display: flex;
  width: 96.5%;
  margin-left: 20px;
  padding: 8px 16px;
  justify-content: start;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 9px;
  background: var(--Background-Semantic-Warning-Subtle, #FFEDE2);
}

.aleta-nao-processado p {
  color: #6D3900;
}
</style>







